<button
  class="flex w-[264px] items-center gap-2 rounded-2xl px-3 py-2"
  [routerLink]="route"
  [disabled]="state().includes(StepState.Disabled)"
  (click)="onStepClick(stepNumber)"
  [class.bg-background-light-blue]="state().includes(StepState.Active)"
>
  <div
    class="flex h-8 w-8 items-center justify-center rounded-full text-h4 font-medium leading-[15px] text-text-tertiary"
    [class.bg-background-light-blue]="state().includes(StepState.Disabled) || state().includes(StepState.Completed)"
    [class.text-text-light]="state().includes(StepState.Disabled)"
    [class.bg-primary-blue]="state().includes(StepState.CurrentInContract)"
    [class.text-text-white]="state().includes(StepState.CurrentInContract)"
    [class.border-2]="state().includes(StepState.Completed)"
    [class.border-primary-blue]="state().includes(StepState.Completed)"
  >
    @if (state().includes(StepState.Completed)) {
      <svg-icon class="text-text-blue" key="px-40-check" size="md"></svg-icon>
    } @else {
      {{ numberToDisplay() }}
    }
  </div>
  <span class="whitespace-nowrap">{{ title }}</span>
</button>
